import React, { useState, useContext } from "react";
import AddSector from '../components/Sector/AddSector';
import AuthContext from "../AuthContext";
import AllSector from '../components/Sector/AllSectors';
import UpdateSector from '../components/Sector/UpdateSector';

function Inventory() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [updatePage, setUpdatePage] = useState(true);

  const {centre,userType} = useContext(AuthContext);

  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  const updateProductModalSetting = (selectedProductData) => {
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };

  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">

        {/* Add Sector Modal */}
        {showProductModal && (
          <AddSector
            addProductModalSetting={addProductModalSetting}
            handlePageUpdate={handlePageUpdate}
            centre={centre}
            userType={userType}
          />
        )}

        {/* Update Sector Modal */}
        {showUpdateModal && (
          <UpdateSector
            updateProductData={updateProduct}
            handlePageUpdate={handlePageUpdate}
            centre={centre}
            userType={userType}
            updateModalSetting={updateProductModalSetting}
          />
        )}

        {/* Table */}
        <div className="overflow-x-auto rounded-md bg-white border border-gray-200 shadow-lg">
          <div className="flex justify-between p-4 bg-gray-100 border-b border-gray-200">
            <h2 className="font-bold text-lg text-gray-700">Sector</h2>
            <div className="flex gap-4">
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 text-sm rounded-sm shadow-md transition duration-300"
                onClick={addProductModalSetting}
              >
                Add Sector
              </button>
            </div>
          </div>
          <AllSector 
            updateProductModalSetting={updateProductModalSetting}
            handlePageUpdate={handlePageUpdate}
            centre={centre}
            userType={userType}
          />
        </div>
      </div>
    </div>
  );
}

export default Inventory;
